import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  PdfDownloadStatus,
  selectControlCount,
  selectPdfDownloadStatus,
  selectSelectedAssessment,
  setPdfDownloadStatus,
} from '../../redux/reducers/assessmentReducer';
import { selectFindingsWithTitles } from '../../redux/reducers/findingsReducer';
import AssessmentFindings from './AssessmentFindings';
import { downloadPdf } from './PDFGenerator';
import ReportControls from './ReportControls';
import ReviewDetails from './ReviewDetails';

function AssessmentDone() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const controlCount = useSelector(selectControlCount);
  const assessmentDetails = useSelector(selectSelectedAssessment);
  const findingsWithTitles = useSelector(selectFindingsWithTitles);
  const downloadStatus = useSelector(selectPdfDownloadStatus);

  useEffect(() => () => {
    dispatch(setPdfDownloadStatus(PdfDownloadStatus.INITIAL));
  }, []);

  const callback = () => {
    dispatch(setPdfDownloadStatus(PdfDownloadStatus.DONE));
  };

  const handleDownload = () => {
    dispatch(setPdfDownloadStatus(PdfDownloadStatus.IN_PROGRESS));
    downloadPdf({
      assessmentDetails,
      controlCount,
      findings: findingsWithTitles,
    }, callback);
  };

  const getDownloadText = (status) => {
    switch (status) {
      case PdfDownloadStatus.INITIAL:
        return t('assessment.pdf.download');
      case PdfDownloadStatus.IN_PROGRESS:
        return t('assessment.pdf.loadingDoc');
      case PdfDownloadStatus.DONE:
        return t('assessment.pdf.done');
      default:
        return '';
    }
  };

  return (
    <Box sx={{ maxWidth: '1200px' }}>
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography id='assessment-done-title' variant="header">{`${t('assessment.done.title')}${assessmentDetails.name}`}</Typography>
          <Stack direction="row">
            <Button
              variant="outlined"
              disabled={downloadStatus !== PdfDownloadStatus.INITIAL}
              onClick={downloadStatus === PdfDownloadStatus.INITIAL ? handleDownload : null}
              endIcon={downloadStatus === PdfDownloadStatus.INITIAL ? <SaveIcon /> : null}
            >
              <Typography variant="buttonMedium">{getDownloadText(downloadStatus)}</Typography>
            </Button>
            {/* Download .docx-button removed because of missing functionality */}
            {/* <Button variant="outlined" startIcon={<GetAppOutlinedIcon />}>
              {t('assessment.done.export')}
            </Button> */}
          </Stack>
        </Stack>
        <ReviewDetails readOnly />
        <AssessmentFindings />
        <ReportControls />
      </Stack>
    </Box>
  );
}
export default AssessmentDone;
